module.exports = __webpack_public_path__ + "img/network-map-mobile.d76f2764.png";